import { FunctionTypes } from './../../../components/ContributorSection/helpers';

/** write paste citing section id and testId */
export var SECTION_ID = 'raw-data-citing-section';

/** test ids for form and sections inside it */
var PREFIX_FOR_TEST_IDS = 'raw-data';
export var TestIds = {
  RAW_DATA_FORM: "".concat(PREFIX_FOR_TEST_IDS, "-test-id"),
  RAW_DATA_PUB_INFO: "".concat(PREFIX_FOR_TEST_IDS, "-raw-data-pub-info-sec-test-id")
};
/** raw data section input test ids */
export var RAW_DATA_SECTION_TEST_ID = 'raw-data-citing-section-test-id';
export var RAW_DATA_TITLE_INPUT_TEST_ID = 'raw-data-title-test-id';
export var RAW_DATA_DESC_INPUT_NAME = 'rawdata.desc';
export var RAW_DATA_DESC_INPUT_LABEL = 'Description';
export var SECTION_TITLE = 'Raw data publication info';
export var RawDataRadioRoleOptions = [FunctionTypes.AUTHOR];